<script>

</script>

<footer>
    <h4>Made with <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Beating%20Heart.png" alt="Beating Heart" width="40" height="40" /> by @darmasrmz</h4>
</footer>

<style>
    footer{
        width: 100%;
        font-family: 'Ubuntu', sans-serif;
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #222222;
        color: #efefef;
    }
    h4{
        text-align: center;
        font-size: 3rem;
    }

</style>